export enum ContactPrivileges {
  View = 'cf_view',
  Edit = 'cf_write',
  Delete = 'cf_delete',
}

export type ContactGridData = {
  id: string
  name: string
  email?: string
  phone?: string
  parentId?: string,
}

export type ContactState = {
  contacts: Contact[],
  selectedIndex?: number | null,
  createdId: string | null,
  single?: Contact[] | null,
  creatingContact: Contact | null,
  error: any,
  selected: Contact[],
  ui: {
    isCreatePopupOpen: boolean,
    isLoading: boolean,
  }
}

export interface Contact {
  id: string
  name: string
  fullname?: string
  email?: string
  phone?: string
}
